import template from './operation.html'
import ko from 'knockout'
import getLang from '../../i18n'
import Base from '../../core/base'
import stringHash from 'string-hash'
const FIELDIDAFFIX = '_link'
class OperationList extends Base {
  initialize ({row, col, operationList, rowIndex}) {
    this.row = row
    this.rowIndex = rowIndex
    this.col = col
    this.dropWidth = col.dropWidth || 84
    this.i18nMore = getLang('更多')
    this.orginOperationList = ko.observableArray(operationList)
    this.operationList = ko.computed(() => {
      let list = []
      this.orginOperationList().forEach((operate) => {
        // 如果不设置visible则默认都显示
        if (!operate.visible) {
          list.push(operate)
        }
        // 如果设置visible 且visible方法返回true
        if (operate.visible && operate.visible(this.row)) {
          list.push(operate)
        }
      })
      return list
    })
    // 当数量大于3时，前两个操作
    this.quickList = ko.computed(() => {
      if (this.operationList().length > 3) {
        return this.operationList().slice(0, 2)
      } else {
        return []
      }
    })
    // 更多操作
    this.moreList = ko.computed(() => {
      if (this.operationList().length > 3) {
        return this.operationList().slice(2, this.operationList().length)
      } else {
        return []
      }
    })
    // 鼠标放在more按钮上
    this.isOnMore = ko.observable(false)
    // 鼠标放在更多列表上
    this.isOnPanel = ko.observable(false)
    this.showDropdown = ko.computed(() => {
      return this.isOnMore() || this.isOnPanel()
    })
    this.moreEl = this.$el.querySelector('.y-grid-operation-morectn')
  }
  methods ({ row }) {
    this.getFieldId = function (item) {
      var title = item.title
      if (typeof title === 'function') {
        title = title(row)
      }
      return `op_${stringHash(title)}_${this.rowIndex}${FIELDIDAFFIX}`
    }
    this.enableMore = () => {
      this.isOnMore(true)
    }
    this.disableMore = () => {
      setTimeout(() => {
        this.isOnMore(false)
      }, 200)
    }
    this.enableMorePanel = () => {
      this.isOnPanel(true)
    }
    this.disableMorePanel = () => {
      setTimeout(() => {
        this.isOnPanel(false)
      }, 200)
    }
    // 让title支持函数
    this.formatTitle = (title) => {
      if (typeof title === 'function') {
        return title(row)
      } else {
        return title
      }
    }
    this.operClick = (item, evt) => {
      item.click(row, evt)
      var index = this.orginOperationList.indexOf(item)
      // 为了重新出发visible
      this.orginOperationList.splice(index, 1, item)
    }
    this.visible = (item) => {
      if (item.visible) {
        return item.visible(row)
      } else {
        return true
      }
    }
  }
}
export default {
  name: 'grid-operation',
  init: Base.createViewModel(OperationList),
  template
}



// WEBPACK FOOTER //
// ./src/components/grid/operation.js